export default __webpack_public_path__ + "static/media/map_filters.7d3bff3b.png";